const USER_PROFILE_STORAGE_KEY = 'rapchik_user_profile';

export function saveUserProfile(profile) {
  if (!profile) return;
  try {
    localStorage.setItem(USER_PROFILE_STORAGE_KEY, JSON.stringify(profile));
  } catch (error) {
    console.error('Failed to save user profile to localStorage:', error);
  }
}

export function getStoredUserProfile() {
  try {
    const raw = localStorage.getItem(USER_PROFILE_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    console.error('Failed to read user profile from localStorage:', error);
    return null;
  }
}

export function clearUserProfile() {
  try {
    localStorage.removeItem(USER_PROFILE_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear user profile from localStorage:', error);
  }
}
